module.exports = __webpack_public_path__ + "img/big-indent.dcc5a4cc.svg";